/*
 * Parallax effects for Jaadu Ghar:
 * 1. Image crop frames ([data-jg-parallax] -> [data-jg-parallax-move])
 * 2. Floating bottles, cards, and pots ([data-jg-float], .floating-bottle, .means-bottle, .build-bottle, .build-bottle-mobile, .build-pot-mobile, .magic-card, .magic-postcard, .science-card, .diamond-card)
 */
(function () {
  var MOBILE_MAX = 749;
  var frames = [];
  var floaters = [];
  var activeFrames = [];
  var activeFloaters = [];
  var ticking = false;
  var observer = null;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scaleFor(frame) {
    var raw = getComputedStyle(frame).getPropertyValue('--jg-parallax-scale');
    var value = parseFloat(raw);
    return isNaN(value) ? 1.12 : value;
  }

  function floatSpeedFor(el) {
    var attr = el.getAttribute('data-jg-float') || el.getAttribute('data-jg-float-speed');
    if (attr !== null && attr !== '') {
      var val = parseFloat(attr);
      if (!isNaN(val)) return val;
    }
    if (el.classList.contains('floating-bottle') || el.classList.contains('means-bottle') || el.classList.contains('build-bottle')) {
      return -0.55;
    }
    if (el.classList.contains('build-bottle-mobile')) {
      return -0.40;
    }
    if (el.classList.contains('build-pot-mobile')) {
      return 0.45;
    }
    if (el.classList.contains('magic-card')) {
      return -0.45;
    }
    if (el.classList.contains('magic-postcard')) {
      return -0.45;
    }
    if (el.classList.contains('science-card')) {
      return 0.25;
    }
    if (el.classList.contains('diamond-card')) {
      return -0.35;
    }
    return -0.4;
  }

  function resetFrame(entry) {
    entry.mover.style.transform = '';
  }

  function resetFloater(entry) {
    entry.el.style.removeProperty('--jg-float-y');
    entry.el.style.removeProperty('--jg-float-x');
    entry.el.style.removeProperty('--jg-float-rotate');
  }

  function positionFrame(entry) {
    var rect = entry.frame.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;

    var travel = viewport + rect.height;
    var progress = travel > 0 ? (viewport - rect.top) / travel : 0.5;
    progress = Math.min(1, Math.max(0, progress));

    var range = (rect.height * (entry.scale - 1)) / 2;
    var offset = (0.5 - progress) * 2 * range;

    entry.mover.style.transform =
      'translate3d(0, ' + offset.toFixed(2) + 'px, 0) scale(' + entry.scale + ')';
  }

  function positionFloater(entry) {
    var container = entry.container || entry.el.parentElement || entry.el;
    var rect = container.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;

    var travel = viewport + rect.height;
    var progress = travel > 0 ? (viewport - rect.top) / travel : 0.5;
    progress = Math.min(1, Math.max(0, progress));

    var isMobile = window.innerWidth <= MOBILE_MAX;
    var maxShift = isMobile ? 90 : 180;
    var offset = (progress - 0.5) * entry.speed * maxShift;
    var isRightSide = entry.el.classList.contains('magic-card') || entry.el.classList.contains('build-bottle');
    var floatX = (progress - 0.5) * (isRightSide ? -15 : 15);
    var floatRotate = (progress - 0.5) * (entry.speed > 0 ? 5 : -5);

    entry.el.style.setProperty('--jg-float-y', offset.toFixed(2) + 'px');
    entry.el.style.setProperty('--jg-float-x', floatX.toFixed(2) + 'px');
    entry.el.style.setProperty('--jg-float-rotate', floatRotate.toFixed(2) + 'deg');
  }

  var disabledFrames = false;

  function update() {
    ticking = false;

    if (reduceMotion.matches) {
      if (!disabledFrames) {
        disabledFrames = true;
        frames.forEach(resetFrame);
        floaters.forEach(resetFloater);
      }
      return;
    }

    if (window.innerWidth <= MOBILE_MAX) {
      if (!disabledFrames) {
        disabledFrames = true;
        frames.forEach(resetFrame);
      }
    } else {
      disabledFrames = false;
      activeFrames.forEach(positionFrame);
    }

    activeFloaters.forEach(positionFloater);
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function onIntersect(entries) {
    entries.forEach(function (record) {
      var frameEntry = frames.filter(function (item) {
        return item.frame === record.target;
      })[0];
      if (frameEntry) {
        var idxF = activeFrames.indexOf(frameEntry);
        if (record.isIntersecting && idxF === -1) {
          frameEntry.scale = scaleFor(frameEntry.frame);
          activeFrames.push(frameEntry);
        } else if (!record.isIntersecting && idxF !== -1) {
          activeFrames.splice(idxF, 1);
        }
      }

      var floaterList = floaters.filter(function (item) {
        return item.container === record.target || item.el === record.target;
      });
      floaterList.forEach(function (floaterEntry) {
        var idxFl = activeFloaters.indexOf(floaterEntry);
        if (record.isIntersecting && idxFl === -1) {
          floaterEntry.speed = floatSpeedFor(floaterEntry.el);
          activeFloaters.push(floaterEntry);
        } else if (!record.isIntersecting && idxFl !== -1) {
          activeFloaters.splice(idxFl, 1);
        }
      });
    });

    schedule();
  }

  function collect(root) {
    var scope = root || document;

    var foundFrames = scope.querySelectorAll('[data-jg-parallax]');
    Array.prototype.forEach.call(foundFrames, function (frame) {
      var known = frames.some(function (item) {
        return item.frame === frame;
      });
      if (known) return;

      var mover = frame.querySelector('[data-jg-parallax-move]');
      if (!mover) return;

      var entry = { frame: frame, mover: mover, scale: scaleFor(frame) };
      frames.push(entry);
      if (observer) observer.observe(frame);
    });

    var floaterSelector = '[data-jg-float], [data-jg-float-speed], .floating-bottle, .means-bottle, .build-bottle, .build-bottle-mobile, .build-pot-mobile, .magic-card, .magic-postcard, .diamond-card';
    var foundFloaters = scope.querySelectorAll(floaterSelector);
    Array.prototype.forEach.call(foundFloaters, function (el) {
      var known = floaters.some(function (item) {
        return item.el === el;
      });
      if (known) return;
      if (el.classList.contains('diamond-card') && el.closest('.jaadu-checker')) return;

      var container = el.closest('.section, [class*="jaadu-"], .container') || el.parentElement || el;
      var entry = { el: el, container: container, speed: floatSpeedFor(el) };
      floaters.push(entry);
      if (observer) observer.observe(container);
    });
  }

  function drop(root) {
    frames = frames.filter(function (entry) {
      if (!root.contains(entry.frame)) return true;
      if (observer) observer.unobserve(entry.frame);
      var index = activeFrames.indexOf(entry);
      if (index !== -1) activeFrames.splice(index, 1);
      return false;
    });

    floaters = floaters.filter(function (entry) {
      if (!root.contains(entry.el)) return true;
      if (observer) observer.unobserve(entry.container);
      var index = activeFloaters.indexOf(entry);
      if (index !== -1) activeFloaters.splice(index, 1);
      return false;
    });
  }

  function init() {
    if (!('IntersectionObserver' in window)) return;

    observer = new IntersectionObserver(onIntersect, { rootMargin: '20% 0px' });
    collect(document);
    schedule();

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', schedule);
    } else if (reduceMotion.addListener) {
      reduceMotion.addListener(schedule);
    }

    document.addEventListener('shopify:section:load', function (event) {
      collect(event.target);
      schedule();
    });

    document.addEventListener('shopify:section:unload', function (event) {
      drop(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

